__turbopack_context__.v({
  "center": "i4QDtG_center",
  "left": "i4QDtG_left",
  "logo": "i4QDtG_logo",
  "navbar": "i4QDtG_navbar",
  "progressBar": "i4QDtG_progressBar",
  "progressFill": "i4QDtG_progressFill",
  "quickStartNavbar": "i4QDtG_quickStartNavbar",
  "right": "i4QDtG_right",
  "spacer": "i4QDtG_spacer",
  "unitCounter": "i4QDtG_unitCounter",
});
